/**
 * 认证详情成绩导入
 */
import React from "react";
import { connect } from 'dva';
import { framework_tool, component_tool,utils_tool } from '@/tool'
import 'antd/dist/antd.css';
import { modelUtils } from '@/utils';
let {Session} = utils_tool
let { WizContainer } = framework_tool;
import { ExportExcel } from '@/components/index'
import { width } from "dom7";
import { WizTableForm } from '@/containers/common'

let { WizSpin, WizTypography, WizModal, WizSelect } = component_tool;
const { Paragraph } = WizTypography;

class OrgRemoteEvaluationScoreImport extends WizContainer {

  componentName = 'orgRemoteEvaluationScoreImport';

  constructor(props) {
    super(props);
    this.state = {
    }
  }

  propsAndStateOnChange = {
    importScore: this._handldImport.bind(this),
  };

  /**
   * 保存后返回提示
   * @param nextProps
   * @param nextState
   * @private
   */
  _handldImport(nextProps, nextState) {
    let o = nextProps['importScore']
    if (o['success']) {
      let data = o['data'];
      let str = data.replace(/<br\/>/g,"\n")
      wizNotice.success({
        key:'default',
        message:'成功',
        description: (
          <div>
            <p style={{whiteSpace: "pre-line"}}>{str}</p>
          </div>
        ),
      })
      return true;
    } else {
      wizNotice.error(o.msg ? o.msg : "导入数据出错，请联系相关人员")
      return false;
    }
  }

  /**改变state值 */
  changeScope(key,value,record){
    this.setState({
      [key]:value
    })
  }

  /** 导入成绩 接口待开发*/  
  importScore(other = {}) {
    this.doAction({
      path: 'orgRemoteAuthDetail/importScore',
      payload: {
        key: 'orgRemoteAuthDetail@importScore',
        apiParams: {...other}
      },
      autoInit: true,
    })
  }


  _render() {
    let infoProps = {
      title: '导入说明',
      text: [
        <Paragraph>1、从模版链接中下载模版文件</Paragraph>,
        <Paragraph>2、按照要求格式填写信息</Paragraph>,
        <Paragraph>3. 当完成Excel文件的填写后，点击“上传文件”按钮上传此文件，并点击“导入”系统会校验数据的正确性，并提示错误的数据；在校验无错误的情况下，将数据导入到系统中。</Paragraph>,
      ]
    }

    let operateProps = {
      title: '远程评估详情成绩导入',
      template: {
        label: '模版下载',
        fileName: '模版.xlsx',
        href: constants.files.excel_orgRemoteEvaluationScoreFileImport,
      }
    }

    let submit = (file, fileData) => {
      this.importScore({
        fileData:fileData,
      })
    }
    let { orgRemoteAuthDetailLoading } = this.props;

    return (
      <WizSpin tip={'文件上传中'} spinning={orgRemoteAuthDetailLoading}>
        <ExportExcel
          infoProps={infoProps}
          operateProps={operateProps}
          submit={submit}
        />
      </WizSpin>
    );
  }
}


const mapStateToProps = (state, ownProps) => {
  const { orgRemoteAuthDetail } = state;
  const importScore = modelUtils.getModelEntity(orgRemoteAuthDetail, "orgRemoteAuthDetail@importScore");
  const load = modelUtils.getLoadingState(state, 'orgRemoteAuthDetail')
  return {
    importScore,
    ...load
  }
};

export default connect(mapStateToProps)(OrgRemoteEvaluationScoreImport);
